<template>
  <div class="container mx-auto px-4">
    <div class="sm:px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{classe}}</Header>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <router-link
          :to="{name: 'ListaBambini', params: { id: classeId}, query: { classe: `${classe}`, menuItem: `${$t('all.kids_list')}`}}"
          class="no-underline"
        >
          <div class="flex flex-col justify-between leading-normal relative z-2">
            <div class="flex items-center">
              <img
                class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
                src="/img/LISTA-BAMBINI.png"
              >
              <div>
                <h3 class="text-grey-dark ">{{$t('all.kids_list')}}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <router-link
          :to="{name: 'ListaBambini', params: { id: classeId}, query: { classe: `${classe}`, menuItem: `${$t('all.class_appeal')}`}}"
          class="no-underline"
        >
          <div class="flex flex-col justify-between leading-normal relative z-2">
            <div class="flex items-center">
              <img
                class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
                src="/img/appello.png"
              >
              <div>
                <h3 class="text-grey-dark ">{{$t('all.class_appeal')}}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <router-link
          :to="{name: 'ListaBambini', params: { id: classeId}, query: { classe: `${classe}`, menuItem: `${$t('all.kids_in_class')}`}}"
          class="no-underline"
        >
          <div class="flex flex-col justify-between leading-normal relative z-2">
            <div class="flex items-center">
              <img
                class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
                src="/img/BIMBI_CLASSE.png"
              >
              <div>
                <h3 class="text-grey-dark ">{{$t('all.kids_in_class')}}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <router-link
          :to="{name: 'Communication', params: { id: classeId}, query: { classe: `${classe}`, menuItem: `${$t('all.communication')}`}}"
          class="no-underline"
        >
          <div class="flex flex-col justify-between leading-normal relative z-2">
            <div class="flex items-center">
              <img
                class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
                src="/img/Comunicazioni.png"
              >
              <div>
                <h3 class="text-grey-dark ">{{$t('all.communication')}}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10">
        <router-link
          :to="{name: 'Register', params: { id: classeId}, query: { classe: `${classe}`, menuItem: `${$t('all.register')}`}}"
          class="no-underline"
        >
          <div class="flex flex-col justify-between leading-normal relative z-2">
            <div class="flex items-center">
              <img
                class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
                src="/img/Register.png"
              >
              <div>
                <h3 class="text-grey-dark ">{{$t('all.register')}}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <div class="flex flex-col justify-between leading-normal relative z-2">
          <div class="flex items-center">
            <img
              class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
              src="/img/mensa.png"
            >
            <div>
              <h3 class="text-grey-dark ">{{$t('all.class_mensa')}}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 ">
        <div class="flex flex-col justify-between leading-normal relative z-2">
          <div class="flex items-center">
            <img
              class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
              src="/img/altre_funzioni.png"
            >
            <div>
              <h3 class="text-grey-dark ">{{$t('all.kids_other_features')}}</h3>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['classeId'],
  data() {
    return {
      classe: '',
    };
  },
  mounted() {
    this.classe = this.$route.query.classe;
  },
};
</script>
